import React, {Component} from 'react';
import {ApiClient} from "../libs/apiClient/ApiClient";
import {config, DISPATCH_ID, ROLES, SERVICE_API, SERVICE_RESPONSE} from "../libs/utils/Const";
import {connect} from "react-redux";
import Modal from './Modal';
import $ from 'jquery';

let modal = new Modal();

let apiClient = ApiClient.getInstance();

class SearchItemsActions extends Component {
    state = { category: null }

    componentDidMount() {
        const {setSearchItemsByKeyReference, setSearchItemsByCategoriesReference, updateFavoriteReference, addShoppingCartReference, addBackOrderReference, deleteShoppingCartReference, deleteBackOrderReference, openItemDetailsReference} = this.props;
        setSearchItemsByKeyReference(this.searchItemsByKey);
        updateFavoriteReference(this.updateFavorite);
        addShoppingCartReference(this.addShoppingCart);
        addBackOrderReference(this.addBackOrder);
        deleteBackOrderReference(this.deleteBackOrder);
        deleteShoppingCartReference(this.deleteShoppingCart);
        openItemDetailsReference(this.openItemDetails);
        setSearchItemsByCategoriesReference(this.searchItemsByCategories);
    }

    searchItemsByKey = async (page = 0, typeSearch = 0) => {
        // console.log('con>Here');
        const {sessionReducer: {role}, itemsReducer,  setItemsSearch,setTotalRows, notificationReducer: {showAlert}, configReducer: {history}, enableSpinner} = this.props;
        // const {category} = this.state;
        let key = 'findAll';
        if (itemsReducer.search) {
            key = itemsReducer.search
        }

        let localShoppingCart = undefined;
        // console.log('con>role',key, localShoppingCart,role);
        if (role === ROLES.PUBLIC) {
            localShoppingCart = localStorage.getItem(config.general.localStorageNamed + 'shoppingCart');
            localShoppingCart = JSON.parse(localShoppingCart) || [];
        }

        //
        let seller = JSON.parse(localStorage.getItem(config.general.localStorageNamed + 'PartnerUser'))
        seller = seller ? seller.U_FMB_Handel_Perfil : '';
        enableSpinner(true);
        let response = await apiClient.searchByKey(key, localShoppingCart,page,seller,typeSearch ); //this.state ? this.state.category : null);//category
        enableSpinner(false);
        if (response.status === SERVICE_RESPONSE.SUCCESS) {
            setItemsSearch(response.data.result);
            setTotalRows(response.data.totalRows);
            this.applyFilters(response.data.result);
            history.goItems();
            return;
        }
        showAlert({type: 'error', message: "Aviso: "+response.message, timeOut: 0});
    };

    searchItemsByCategories = async (category, page=0) => {
        const {sessionReducer: {role}, setItemsSearch, setTotalRows,notificationReducer: {showAlert}, configReducer: {history}, enableSpinner} = this.props;
        let localShoppingCart = undefined;
        if (role === ROLES.PUBLIC) {
            localShoppingCart = localStorage.getItem(config.general.localStorageNamed + 'shoppingCart');
            localShoppingCart = JSON.parse(localShoppingCart) || [];
        }

        enableSpinner(true);
        this.setState({ category });
        let seller = JSON.parse(localStorage.getItem(config.general.localStorageNamed + 'PartnerUser'))
        seller = seller ? seller.U_FMB_Handel_Perfil : '';
        // console.log('con< category',category, 'page-', page);
        let response = await apiClient.searchByCategory(category, localShoppingCart, page,seller);
        enableSpinner(false);
        if (response.status === SERVICE_RESPONSE.SUCCESS) {
            // setItemsSearch(response.data);
            // this.applyFilters(response.data);
            setItemsSearch(response.data.result);
            setTotalRows(response.data.totalRows);
            this.applyFilters(response.data.result);
            history.goItems();
            
            return;
        }
        showAlert({type: 'error', message: "Aviso: "+response.message, timeOut: 0});
    };

    applyFilters = data => {
        const {setItemsFilterSearch, enableSpinner} = this.props;
        enableSpinner(true);
        setItemsFilterSearch(data);
        enableSpinner(false);

        $("#menuCategories").removeClass('open-menu-categories');
    };

    updateFavorite = async item => {
        const {sessionReducer: {role}, itemsReducer: {items}, notificationReducer: {showAlert}, enableSpinner} = this.props;
        //console.log("addFavorite", item);


        if (role === ROLES.PUBLIC) {
            await this.needToCreateAccount();
            return;
        }
        enableSpinner(true);
        let response = await apiClient.updateFavorite(item);
        enableSpinner(false);
        if (response.status === SERVICE_RESPONSE.ERROR) {
            showAlert({type: 'error', message: "Aviso: "+response.message, timeOut: 0});
            return;
        }
        item.favorite = response.data.value; // change item details

        items.filter(itemFilter => {
            if (item.ItemCode === itemFilter.ItemCode) {
                itemFilter.favorite = response.data.value;
            }
        });

        this.applyFilters(items);

    };

    needToCreateAccount = () => {
        modal.loginModal('show');
    };

    addShoppingCart = async data => {
        const {enableSpinner,itemsReducer: {items: itemsSearch}, sessionReducer: {role}, shoppingCartReducer: {items}, notificationReducer: {showAlert}, setShoppingCart} = this.props;

        if (role === ROLES.PUBLIC) {
            this.addShoppingCartPublic(data);
            return;
        }
        enableSpinner(true);
        //console.log('DBADDCART',data);
        let response = await apiClient.updateShoppingCart(data);
        
        enableSpinner(false);
        if (response.status === SERVICE_RESPONSE.ERROR) {
            showAlert({type: 'error', message: "Aviso: "+response.message, timeOut: 0});
            return;
        }

        let exist = response.data.value;
        let shoppingCardUpdate = response.data.shoppingCart || [];
        if (!exist) {
            items.push({ItemCode: data.item.ItemCode, quantity: data.quantity});
            setShoppingCart(items);
        }

        for (let index = 0; index < shoppingCardUpdate.length; index++) {
            const itemUpdate = shoppingCardUpdate[index];
            for (let index = 0; index < items.length; index++) {
                const item = items[index];
                if (item.ItemCode === itemUpdate.ItemCode && data.item.ItemCode === itemUpdate.ItemCode) {
                    item.quantity = data.quantity;
                    item.Discount = itemUpdate.Discount;
                }
            }
        }

        let newItem = undefined;
        itemsSearch.map(itemFilter => {
            if (itemFilter.ItemCode === data.item.ItemCode) {
                itemFilter.quantity = data.quantity;
                newItem = data.item;
                newItem.quantity = data.quantity;
            }
        });

 /*       let newItemShooping = undefined;
        items.map( itemShopping => {
            if (itemShopping.ItemCode === data.item.ItemCode) {
                itemShopping.quantity = data.quantity;
                newItemShooping = data.item;
                newItemShooping.quantity = data.quantity;
            }
        });
*/
        this.applyFilters(itemsSearch);
        //this.changeInfoDetails(newItem);
        //this.changeShoppingCart(items);
        await setShoppingCart(items);
    };

    addShoppingCartPublic = async data => {
        const {itemsReducer: {items: itemsSearch}, shoppingCartReducer: {items}, setShoppingCart} = this.props;
        //console.log("addShoppingCart", data);

        let localShoppingCart = localStorage.getItem(config.general.localStorageNamed + 'shoppingCart');
        localShoppingCart = JSON.parse(localShoppingCart) || [];

        let exist = localShoppingCart.filter((itemFilter) => {
            return (itemFilter.ItemCode === data.item.ItemCode)
        });

        if (!exist.length) {
            localShoppingCart.push({ItemCode: data.item.ItemCode, quantity: data.quantity});
            items.push({ItemCode: data.item.ItemCode, quantity: data.quantity});
        } else {
            localShoppingCart.map((itemMap) => {
                if (data.item.ItemCode === itemMap.ItemCode) {
                    itemMap.quantity = data.quantity;
                }
            });
            items.map((itemMap) => {
                if (data.item.ItemCode === itemMap.ItemCode) {
                    itemMap.quantity = data.quantity;
                }
            });
        }


        let newItem = undefined;
        itemsSearch.map(itemFilter => {
            if (itemFilter.ItemCode === data.item.ItemCode) {
                itemFilter.quantity = data.quantity;
                newItem = data.item;
                newItem.quantity = data.quantity;
            }
        });

        /*let newItemShooping = undefined;
        localShoppingCart.map( itemShopping => {
            if (itemShopping.ItemCode === data.item.ItemCode) {
                itemShopping.quantity = data.quantity;
                newItemShooping = data.item;
                newItemShooping.quantity = data.quantity;
            }
        });
*/
        items.map( itemFilter => {
            if(data.item.ItemCode === itemFilter.ItemCode){
                itemFilter.quantity = data.quantity;
            }
        });

        localStorage.setItem(config.general.localStorageNamed + 'shoppingCart', JSON.stringify(localShoppingCart));
        setShoppingCart(items);

        this.applyFilters(itemsSearch);
        //this.changeInfoDetails(newItem);
    };


    deleteShoppingCart = async data => {
        const {itemsReducer: {items: itemsSearch}, sessionReducer: {role}, shoppingCartReducer: {items}, notificationReducer: {showAlert}, setShoppingCart} = this.props;
        //console.log("deleteShoppingCart", data);

        if (role === ROLES.PUBLIC) {
            this.deleteShoppingCartPublic(data);
            return;
        }

        let response = await apiClient.deleteShoppingCart(data);
        if (response.status === SERVICE_RESPONSE.ERROR) {
            showAlert({type: 'error', message: "Aviso: "+response.message, timeOut: 0});
            return;
        }

        let newItems = items.filter(itemFilter => {
            return (itemFilter.ItemCode !== data.item.ItemCode)
        });

        if (data.deleteAll) {
            newItems = [];
        }
        setShoppingCart(newItems);

        let newItem = undefined;
        itemsSearch.map(itemFilter => {
            if (itemFilter.ItemCode === data.item.ItemCode) {
                itemFilter.quantity = '';
                newItem = data.item;
                newItem.quantity = '';
            }
        });
        this.applyFilters(itemsSearch);
      //  this.changeInfoDetails(newItem);
    };

    deleteShoppingCartPublic = data => {
        const {itemsReducer: {items: itemsSearch},shoppingCartReducer: {items}, setItemsSearch, setShoppingCart} = this.props;
        //console.log("deleteShoppingCart", data);

        let localShoppingCart = localStorage.getItem(config.general.localStorageNamed + 'shoppingCart');

        localShoppingCart = JSON.parse(localShoppingCart) || [];

        let newItems = items.filter(itemFilter => {
            return (itemFilter.ItemCode !== data.item.ItemCode)
        });

        if (data.deleteAll) {
            newItems = [];
        }

        localStorage.setItem(config.general.localStorageNamed + 'shoppingCart', JSON.stringify(newItems));
        setShoppingCart(newItems);

        let newItem = undefined;
        itemsSearch.map(itemFilter => {
            if (itemFilter.ItemCode === data.item.ItemCode) {
                itemFilter.quantity = '';
                newItem = data.item;
                newItem.quantity = '';
            }
        });
        this.applyFilters(itemsSearch);
        //this.changeInfoDetails(newItem);
    };

    addBackOrder = async data => {
        const {itemsReducer: {items}, sessionReducer: {role}, shoppingCartReducer: {backOrder}, notificationReducer: {showAlert}, enableSpinner, setBackOrder} = this.props;
        //console.log("addBackOrder", data);

        if (role === ROLES.PUBLIC) {
            this.needToCreateAccount();
            return;
        }

        enableSpinner(true);
        let response = await apiClient.updateBackOrder(data);
        enableSpinner(false);
        if (response.status === SERVICE_RESPONSE.ERROR) {
            showAlert({type: 'error', message: "Aviso: "+response.message, timeOut: 0});
            return;
        }

        let exist = response.data.value;
        if (!exist) {
            backOrder.push({ItemCode: data.item.ItemCode, quantity: data.quantity});
            setBackOrder(backOrder);
        }

        let newItem = undefined;
        items.map(itemFilter => {
            if (itemFilter.ItemCode === data.item.ItemCode) {
                itemFilter.backOrder = true;
                newItem = data.item;
                newItem.backOrder = true;
            }
        });
        this.applyFilters(items);
        //this.changeInfoDetails(newItem);
    };


    deleteBackOrder = async data => {
        const {itemsReducer: {items}, sessionReducer: {role}, shoppingCartReducer: {backOrder}, notificationReducer: {showAlert}, enableSpinner, setBackOrder} = this.props;
        //console.log("deleteBackOrder", data);

        if (role === ROLES.PUBLIC) {
            this.needToCreateAccount();
            return;
        }

        enableSpinner(true);
        let response = await apiClient.deleteBackOrder(data);
        enableSpinner(false);
        if (response.status === SERVICE_RESPONSE.ERROR) {
            showAlert({type: 'error', message: "Aviso: "+response.message, timeOut: 0});
            return;
        }

        let newItems = backOrder.filter(itemFilter => {
            return (itemFilter.ItemCode !== data.item.ItemCode)
        });

        if (data.deleteAll) {
            newItems = [];
        }


        setBackOrder(newItems);

        let newItem = undefined;
        items.map(itemFilter => {
            if (itemFilter.ItemCode === data.item.ItemCode) {
                itemFilter.backOrder = false;
                newItem = data.item;
                newItem.backOrder = false;
            }
        });
        this.applyFilters(items);
        //this.changeInfoDetails(newItem);
    };

    openItemDetails = async item => {
        const {sessionReducer: {role}, setItemDetailsSearch, notificationReducer: {showAlert}, configReducer: {history}, enableSpinner} = this.props;

        let localShoppingCart = undefined;
        if (role === ROLES.PUBLIC) {
            localShoppingCart = localStorage.getItem(config.general.localStorageNamed + 'shoppingCart');
            localShoppingCart = JSON.parse(localShoppingCart) || [];
        }

        enableSpinner(true);
        let response = await apiClient.openItemDetails(item.ItemCode, localShoppingCart);
        enableSpinner(false);
        if (response.status === SERVICE_RESPONSE.ERROR) {
            showAlert({type: 'error', message: "Aviso: "+response.message, timeOut: 0});
            return;
        }

        let images = [];
        images.push({path: (response.data.PicturName ? (config.BASE_URL + SERVICE_API.getImage + '/' + response.data.PicturName) : require('../images/noImage.png'))});

        let imagesArray = response.data.U_Handel_ImagesArray || '';
        imagesArray = imagesArray.split('|');

        imagesArray.map( image => {
            //console.log("ccccccccccccccccccccccccccccccccc", image);
            if(image){
                images.push({path: (image ? (config.BASE_URL + SERVICE_API.getImage + '/' + image) : require('../images/noImage.png'))});
            }
        });

        let files = [];
        let fileArray = response.data.U_Handel_attachment || '';
        fileArray = fileArray.split('|');
        //console.log("splittttttttt", fileArray)
        fileArray.map( file => {
            if(file){
                files.push({path: (file ? (config.BASE_URL + SERVICE_API.getFile + '/' + file) : '' ), name: file});
            }
        });

        response.data.images = images;
        response.data.files = files;

        setItemDetailsSearch(response.data);

        setTimeout(() => {
            modal.itemDetails('show');
            //$('#input-quantity-details-' + response.data.ItemCode).val('');
        }, 10)

    };

    changeInfoDetails = item => {
        const {setItemDetailsSearch} = this.props;
        if (item) {
            setItemDetailsSearch(item);
        }
    };


    render() {
        return (
            <div>
            </div>
        );
    }
}

const mapStateToProps = store => {
    return {
        itemsReducer: store.ItemsReducer,
        sessionReducer: store.SessionReducer,
        shoppingCartReducer: store.ShoppingCartReducer,
        configReducer: store.ConfigReducer,
        notificationReducer: store.NotificationReducer,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        openItemDetailsReference: value => dispatch({type: DISPATCH_ID.ITEMS_OPEN_ITEM_DETAILS_REFERENCE, value}),
        updateFavoriteReference: value => dispatch({type: DISPATCH_ID.ITEMS_UPDATE_FAVORITE_REFERENCE, value}),
        addShoppingCartReference: value => dispatch({type: DISPATCH_ID.ITEMS_ADD_SHOPPING_CART_REFERENCE, value}),
        addBackOrderReference: value => dispatch({type: DISPATCH_ID.ITEMS_ADD_BACK_ORDER_REFERENCE, value}),
        deleteBackOrderReference: value => dispatch({type: DISPATCH_ID.ITEMS_DELETE_BACK_ORDER_REFERENCE, value}),
        deleteShoppingCartReference: value => dispatch({type: DISPATCH_ID.ITEMS_DELETE_SHOPPING_CART_REFERENCE, value}),
        setSearchItemsByKeyReference: value => dispatch({type: DISPATCH_ID.ITEMS_SET_SEARCH_BY_KEY_REFERENCE, value}),
        setSearchItemsByCategoriesReference: value => dispatch({type: DISPATCH_ID.ITEMS_SET_SEARCH_BY_CATEGORIES_REFERENCE, value}),
        setItemsSearch: value => dispatch({type: DISPATCH_ID.ITEMS_SET_ITEMS, value}),
        setTotalRows : value => dispatch({type: DISPATCH_ID.ITEMS_SET_TOTALROWS, value}),
        setItemsFilterSearch: value => dispatch({type: DISPATCH_ID.ITEMS_SAVE_ITEMS_FILTER, value}),
        setItemDetailsSearch: value => dispatch({type: DISPATCH_ID.ITEMS_SET_ITEM_DETAILS, value}),
        enableSpinner: value => dispatch({type: DISPATCH_ID.CONFIG_SET_SPINNER, value}),
        setShoppingCart: value => dispatch(
            {
                type: DISPATCH_ID.SHOPPING_CART_SAVE_CART, 
                value
            }
        ),
        setBackOrder: value => dispatch({type: DISPATCH_ID.SHOPPING_CART_SAVE_BACK_ORDER, value}),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SearchItemsActions)